(function () {
  var THRESHOLD = 3;
  var prevCount = null;

  // Inject CSS once
  if (!document.getElementById('ww-pb-styles')) {
    var style = document.createElement('style');
    style.id = 'ww-pb-styles';
    style.textContent =
      '.ww-pb-wrap{background:#f0faf0;border:1px solid #c8e6c9;border-radius:10px;padding:14px 16px;margin:14px 0;position:relative;}' +
      '.ww-pb-wrap.unlocked{background:#e8f5e9;border-color:#81c784;}' +
      '.ww-pb-wrap.glowing{box-shadow:0 0 18px #81c784;}' +
      '.ww-pb-msg{margin:0 0 10px;font-size:13px;color:#2e4a2e;text-align:center;line-height:1.4;}' +
      '.ww-pb-labels{display:flex;justify-content:space-between;margin-top:6px;}' +
      '.ww-pb-label{font-size:11px;color:#5a8a5a;opacity:.6;}' +
      '.ww-pb-label.done{opacity:1;font-weight:600;color:#2e7d32;}' +
      '.ww-pb-goal{font-weight:600;position:relative;}' +
      '@keyframes ww-pop{0%{transform:translateY(0) scale(.5);opacity:1}70%{transform:translateY(-35px) scale(1.2);opacity:1}100%{transform:translateY(-60px) scale(.9);opacity:0}}' +
      '.ww-emoji{position:absolute;bottom:0;font-size:18px;pointer-events:none;animation:ww-pop 1.1s ease forwards;z-index:999;}';
    document.head.appendChild(style);
  }

  // Transition is in inline style so it survives AJAX section re-renders
  var RECT_BASE_STYLE = 'transform-origin:left center;transition:transform 0.6s ease;transform:scaleX(0);';

  function buildBarHTML() {
    return '<div class="ww-pb-wrap" data-ww-progress>' +
      '<p class="ww-pb-msg">Add <strong>2 prints</strong> and get 1 FREE 🎁</p>' +
      '<svg class="ww-pb-track" width="100%" height="12" style="display:block;border-radius:99px;overflow:hidden;margin-bottom:6px;">' +
        '<rect width="100%" height="12" fill="#e8f5e9"/>' +
        '<rect class="ww-pb-fill-rect" width="100%" height="12" fill="#43a047" style="' + RECT_BASE_STYLE + '"/>' +
      '</svg>' +
      '<div class="ww-pb-labels">' +
        '<span class="ww-pb-label">1 print</span>' +
        '<span class="ww-pb-label">2 prints</span>' +
        '<span class="ww-pb-label ww-pb-goal">&#127873; Free!</span>' +
      '</div>' +
    '</div>';
  }

  function injectProductPageBar() {
    if (!window.location.pathname.match(/\/products\//)) return;

    var btn = document.querySelector('button[name="add"]');
    if (!btn) return;

    var anchor = btn.closest('.product-form-wrapper') || btn.closest('form') || btn.parentElement;
    if (!anchor) return;
    if (anchor.querySelector('[data-ww-progress]')) return;

    var wrap = document.createElement('div');
    wrap.innerHTML = buildBarHTML();
    anchor.parentNode.insertBefore(wrap.firstChild, anchor.nextSibling);

    // Double rAF: lets browser paint scaleX(0) before we animate to real value
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fetch_cart();
      });
    });
  }

  function getCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      var t = (item.title || '').toLowerCase();
      var isFrame = t.indexOf('oak frame') > -1 ||
        (t.indexOf('frame') > -1 && t.indexOf('poster') === -1 && t.indexOf('print') === -1);
      if (isFrame) return;
      if (t.indexOf('set of 3') > -1) {
        n += 3 * item.quantity;
      } else {
        n += item.quantity;
      }
    });
    return n;
  }

  function msg(n) {
    if (n <= 0) return 'Add <strong>2 prints</strong> and get 1 FREE 🎁';
    if (n === 1) return 'Add <strong>1 more print</strong> to unlock a FREE print 🛒';
    if (n === 2) return 'Almost there! Add <strong>1 more</strong> and get it <strong>FREE</strong> 🎉';
    return '🎉 <strong>Free print unlocked!</strong> You\'ve earned a free print — don\'t leave without it!';
  }

  function celebrate(wrap) {
    wrap.classList.add('glowing');
    setTimeout(function () { wrap.classList.remove('glowing'); }, 2000);

    var goal = wrap.querySelector('.ww-pb-goal');
    if (goal) {
      ['🎉', '✨', '🎊'].forEach(function (e, i) {
        setTimeout(function () {
          var el = document.createElement('span');
          el.className = 'ww-emoji';
          el.textContent = e;
          el.style.left = (8 + i * 28) + '%';
          goal.appendChild(el);
          setTimeout(function () { el.remove(); }, 1200);
        }, i * 160);
      });
    }
  }

  function update(count) {
    var pct = Math.min(count / THRESHOLD * 100, 100);
    var unlocked = count >= THRESHOLD;
    var doC = prevCount !== null && prevCount < THRESHOLD && unlocked;

    document.querySelectorAll('[data-ww-progress]').forEach(function (wrap) {
      var m = wrap.querySelector('.ww-pb-msg');
      if (m) m.innerHTML = msg(count);

      var fillRect = wrap.querySelector('.ww-pb-fill-rect');
      if (fillRect) {
        fillRect.style.transform = 'scaleX(' + (pct / 100) + ')';
        fillRect.setAttribute('fill', unlocked ? '#2e7d32' : '#43a047');
      }

      var labels = wrap.querySelectorAll('.ww-pb-label');
      if (labels[0]) labels[0].classList.toggle('done', count >= 1);
      if (labels[1]) labels[1].classList.toggle('done', count >= 2);
      if (labels[2]) labels[2].classList.toggle('done', unlocked);

      wrap.classList.toggle('unlocked', unlocked);
      if (doC) setTimeout(function () { celebrate(wrap); }, 400);
    });

    prevCount = count;
  }

  function fetch_cart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { update(getCount(c)); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', fetch_cart);
  document.addEventListener('cart:refresh', fetch_cart);

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1 && n.querySelector && n.querySelector('[data-ww-progress]')) {
          setTimeout(fetch_cart, 300);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectProductPageBar);
  } else {
    injectProductPageBar();
  }

}());